module.exports = __webpack_public_path__ + "static/media/gold.3a319fff.png";